/*
  Polyfill used to make classList.add work on SVG element in Intrenet explorer
*/
if (!Object.getOwnPropertyDescriptor(Element.prototype, "classList")) {
  if (
    HTMLElement &&
    Object.getOwnPropertyDescriptor(HTMLElement.prototype, "classList")
  ) {
    Object.defineProperty(
      Element.prototype,
      "classList",
      Object.getOwnPropertyDescriptor(HTMLElement.prototype, "classList")
    );
  }
}
